// extracted by mini-css-extract-plugin
module.exports = {"section":"slider-module--section--3-U55","image":"slider-module--image--1JvP2"};